import { useSatelliteWebLandlordTouringHandler_scheduleTour } from '@zg-rentals/ts-satellite-client-react-query';
import { ZCALENDAR_TOURS_QUERY_TAG } from '@zg-rentals/touring';

/** Adds a tour the landlord agreed on with the conversation's renter; refetches every tour query on success. */
export default function useScheduleTour() {
  return useSatelliteWebLandlordTouringHandler_scheduleTour({
    meta: {
      invalidates: [ZCALENDAR_TOURS_QUERY_TAG],
      context: {
        api: 'scheduleTour',
        details: 'useScheduleTour - adding a tour from the conversation',
      },
    },
  });
}
